import React from 'react';
import { Alert, AlertIcon, AlertTitle, AlertDescription, CloseButton, Box } from '@chakra-ui/react';

interface ErrorAlertProps {
  status?: 'error' | 'success' | 'warning' | 'info';
  title?: string;
  message: string | null;
  onClose?: () => void;
  mt?: number | string;
  borderRadius?: string;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({
  status = 'error',
  title,
  message,
  onClose,
  mt = 4,
  borderRadius = 'md',
}) => {
  if (!message) return null;

  return (
    <Alert status={status} borderRadius={borderRadius} mt={mt} position="relative">
      <AlertIcon />
      <Box>
        {title && <AlertTitle>{title}</AlertTitle>}
        <AlertDescription>{message}</AlertDescription>
      </Box>
      {onClose && (
        <CloseButton position="absolute" right="8px" top="8px" onClick={onClose} />
      )}
    </Alert>
  );
};

export default ErrorAlert;
